/*
 * Copyright (c) 2021 Signum+ Software & Facility GmbH
 * Author: sebastian.woess@signum-plus.at
 */

import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
  NgZone,
  Input,
  HostBinding,
} from '@angular/core';
import { ChangedEvent, TextService } from '@typescript-kit/core';
import { CheckboxModel, ComponentModel, TextModel, ViewComponentKey } from '@typescript-kit/view';
import { BaseDirective } from '../../directive/base.directive';

@Component({
  selector: 'kit-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent extends BaseDirective<CheckboxModel> {
  private static incrementingId = 0;

  id = `kit-checkbox-${CheckboxComponent.incrementingId++}`;

  private _labelModel: ComponentModel;

  constructor(
    changeDetector: ChangeDetectorRef,
    elementRef: ElementRef,
    renderer: Renderer2,
    ngZone: NgZone,
    textService: TextService
  ) {
    super(changeDetector, elementRef, renderer, ngZone, textService);
  }

  @Input()
  set kitCheckbox(value: CheckboxModel) {
    this.model = value;
  }

  get labelModel(): ComponentModel {
    return this._labelModel;
  }

  @HostBinding('class')
  get labelPositionClass(): string {
    return `kit-checkbox-${this.model?.labelPosition ?? 'right'}`;
  }

  get hostClass() {
    return 'kit-checkbox';
  }

  protected onModelChanged(model: CheckboxModel) {
    super.onModelChanged(model);
    this.refreshLabel();
  }

  protected onModelPropertyChanged(event: ChangedEvent): void {
    super.onModelPropertyChanged(event);
    if (event.changes['label']) {
      this.refreshLabel();
    }
  }

  protected refreshLabel() {
    if (typeof this.model.label === 'string') {
      this._labelModel = new TextModel({
        type: ViewComponentKey.LABEL,
        text: this.model.label
      });
    } else if (this.model.label === true) {
      const scope = this.model.scope;
      const key = this.model.key;
      this._labelModel = new TextModel({
        type: ViewComponentKey.LABEL,
        text: scope ? `${scope}/${key}` : key
      });
    } else if (this.model.label instanceof ComponentModel) {
      this._labelModel = this.model.label;
    } else {
      this._labelModel = null;
    }
  }

  protected refreshTabIndex() {
    // Prevent tab index from being set
  }
}
